import React from "react";

import { useRouteMatch } from "react-router-dom";
import BackButtom from "../../../../components/backButton";
import FormFactory from "../../../../components/form/form-factory";

import * as S from "./styles";

import IFormPage from "../../../../interfaces/form-page";

type IProps = any & IFormPage;

const CompanyEdit: React.FC<IProps> = ({
  dataForm,
  onSubmit,
  errorMessage,
}) => {
  const match = useRouteMatch<{ action: string }>([
    "/admin/developers/edit/:id",
    "/admin/developers/view/:id",
  ]);
  return (
    <S.Wrapper>
      <BackButtom
        text={
          match?.path.includes("edit")
            ? "Editar dados do usuário"
            : "Dados do usuário"
        }
      />
      <S.CardContent>
        <FormFactory
          data={dataForm}
          onSubmit={onSubmit}
          submitErrorMessage={errorMessage}
          onlyView={!match?.path.includes("edit")}
          optionsExtra={{
            isRegister: true,
          }}
        />
      </S.CardContent>
    </S.Wrapper>
  );
};
export default CompanyEdit;
